export default __webpack_public_path__ + "static/media/storexplore-live-sales.0f9d7e60.png";